import axios from '~/utils/axios';
import { Menu, MenuItem } from '~/types/Menu';

export const deleteMenu = (id: string) => {
  return axios.delete<void>(`/menu/${id}`).then((res) => res.data);
};

export const deleteItem = (props: { menuId: string; itemId: string }) => {
  const { menuId, itemId } = props;
  return axios.delete<void>(`/menu/${menuId}/items/${itemId}`).then((res) => res.data);
};

export const fetchInitialChildren = (id: string) => {
  return axios.get<MenuItem[]>(`/menu/${id}/items/$/children`).then((res) => res.data);
};

export const fetchChildrenById = (props: { menuId: string; itemId: string }) => {
  const { menuId, itemId } = props;
  return axios.get<MenuItem[]>(`/menu/${menuId}/items/${itemId}/children`).then((res) => res.data);
};

export const fetchMenu = () => {
  return axios.get<Menu[]>(`/menu?page=1&perPage=9999`).then((res) => res.data);
};

export const fetchMenuItemById = (id: string) => {
  return axios.get<MenuItem>(`/menu/items/${id}`).then((res) => res.data);
};
